export async function apiFetch(path, options = {}) {
  const response = await fetch(path, {
    credentials: 'include',
    headers: {
      ...(options.body instanceof FormData ? {} : { 'Content-Type': 'application/json' }),
      ...(options.headers || {})
    },
    ...options
  });

  const contentType = response.headers.get('Content-Type') || '';
  const payload = contentType.includes('application/json')
    ? await response.json()
    : { ok: response.ok, message: await response.text() };

  if (!response.ok) {
    throw new Error(payload.message || `Request failed with ${response.status}`);
  }

  return payload;
}

export function getMe() {
  return apiFetch('/api/me');
}

export function requestMagicLink(email, turnstileToken = '') {
  return apiFetch('/api/auth/request-link', {
    method: 'POST',
    body: JSON.stringify({ email, turnstileToken })
  });
}

export function logout() {
  return apiFetch('/api/auth/logout', { method: 'POST' });
}

export function getOverview(clientId = '') {
  const suffix = clientId ? `?clientId=${encodeURIComponent(clientId)}` : '';
  return apiFetch(`/api/overview${suffix}`);
}

export function createChangeRequest(payload) {
  return apiFetch('/api/requests', {
    method: 'POST',
    body: JSON.stringify(payload)
  });
}

export function getRequest(requestId) {
  return apiFetch(`/api/requests/${encodeURIComponent(requestId)}`);
}

export function addRequestComment(requestId, payload) {
  return apiFetch(`/api/requests/${encodeURIComponent(requestId)}/comments`, {
    method: 'POST',
    body: JSON.stringify(payload)
  });
}

export function uploadClientFile(formData) {
  return apiFetch('/api/files', {
    method: 'POST',
    body: formData
  });
}

export function openStripePortal(clientId) {
  return apiFetch('/api/billing/portal', {
    method: 'POST',
    body: JSON.stringify({ clientId })
  });
}

export function createClient(payload) {
  return apiFetch('/api/clients', {
    method: 'POST',
    body: JSON.stringify(payload)
  });
}

export function onboardClient(payload) {
  return apiFetch('/api/admin/onboard', {
    method: 'POST',
    body: JSON.stringify(payload)
  });
}

export function updateClientServiceLevel(payload) {
  return apiFetch('/api/admin/service-level', {
    method: 'PATCH',
    body: JSON.stringify(payload)
  });
}

export function inviteUser(payload) {
  return apiFetch('/api/admin/invite', {
    method: 'POST',
    body: JSON.stringify(payload)
  });
}

export function createProject(payload) {
  return apiFetch('/api/projects', {
    method: 'POST',
    body: JSON.stringify(payload)
  });
}

export function createSite(payload) {
  return apiFetch('/api/sites', {
    method: 'POST',
    body: JSON.stringify(payload)
  });
}

export function createBillingRecord(payload) {
  return apiFetch('/api/billing', {
    method: 'POST',
    body: JSON.stringify(payload)
  });
}

export function getRevenueCompanies(params = {}) {
  const search = new URLSearchParams();
  if (params.status && params.status !== 'all') search.set('status', params.status);
  if (params.limit) search.set('limit', String(params.limit));
  const suffix = search.toString() ? `?${search.toString()}` : '';
  return apiFetch(`/api/revenue/companies${suffix}`);
}

export function getChetzelsReviewSessions(params = {}) {
  const search = new URLSearchParams();
  if (params.limit) search.set('limit', String(params.limit));
  const suffix = search.toString() ? `?${search.toString()}` : '';
  return apiFetch(`/api/public/chetzels-wireframe-review${suffix}`);
}

export function getChetzelsReviewSession(sessionId) {
  return apiFetch(`/api/public/chetzels-wireframe-review?sessionId=${encodeURIComponent(sessionId)}`);
}

export function createRevenueCompanies(payload) {
  return apiFetch('/api/revenue/companies', {
    method: 'POST',
    body: JSON.stringify(payload)
  });
}

export function getRevenueDiscovery(payload = {}) {
  return apiFetch('/api/revenue/discovery', {
    method: 'POST',
    body: JSON.stringify(payload)
  });
}

export function getRevenueAudit(companyId) {
  return apiFetch(`/api/revenue/companies/${encodeURIComponent(companyId)}/audit`);
}

export function generateRevenueAudit(companyId) {
  return apiFetch(`/api/revenue/companies/${encodeURIComponent(companyId)}/audit`, {
    method: 'POST'
  });
}

export function updateRevenueCompany(companyId, payload) {
  return apiFetch(`/api/revenue/companies/${encodeURIComponent(companyId)}`, {
    method: 'PATCH',
    body: JSON.stringify(payload)
  });
}

export function getBottleneckLeads(params = {}) {
  const search = new URLSearchParams();
  if (params.status && params.status !== 'all') search.set('status', params.status);
  if (params.fitTier && params.fitTier !== 'all') search.set('fitTier', params.fitTier);
  if (params.q) search.set('q', params.q);
  if (params.limit) search.set('limit', String(params.limit));
  const suffix = search.toString() ? `?${search.toString()}` : '';
  return apiFetch(`/api/admin/bottlenecks${suffix}`);
}

export function getBottleneckLead(leadId) {
  return apiFetch(`/api/admin/bottlenecks/${encodeURIComponent(leadId)}`);
}

export function updateBottleneckLead(leadId, payload) {
  return apiFetch(`/api/admin/bottlenecks/${encodeURIComponent(leadId)}`, {
    method: 'PATCH',
    body: JSON.stringify(payload)
  });
}

export function convertBottleneckLead(leadId, payload = {}) {
  return apiFetch(`/api/admin/bottlenecks/${encodeURIComponent(leadId)}/convert`, {
    method: 'POST',
    body: JSON.stringify(payload)
  });
}
